import { render, staticRenderFns } from "./ModuleKDATarget.vue?vue&type=template&id=2cfc7f51&scoped=true"
import script from "./ModuleKDATarget.vue?vue&type=script&lang=js"
export * from "./ModuleKDATarget.vue?vue&type=script&lang=js"
import style0 from "./ModuleKDATarget.vue?vue&type=style&index=0&id=2cfc7f51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc7f51",
  null
  
)

export default component.exports